import * as React from 'react';
import { Button } from "@progress/kendo-react-buttons";
import styled from "styled-components";

import Popup from "../components/CusPopup";

const ButtonToggle = styled(Button)`
color: blue;
opacity: 0.7;
background-color: transparent;
background-repeat: no-repeat;
border: none;
margin-top: -0.4em;
margin-left: -0.4em;
&:hover {
    background-color: transparent;
  }
${({ active }) =>
        active &&
        `
opacity: 1; 
`}
`;

const CusCancelApp = (props) => {

    return (

        <div style={{ textAlign: 'center' }}>
            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <span>To cancel the Application,</span>&nbsp;
                    <span onClick={props.onClick} style={{ color: 'blue' }} ><u>Click here</u></span>
                </div>
            </div>
            <Popup
                className="popUpBox"
                trigger={props.pTrigger}
                setTrigger={props.psetTrigger}>
                
                <div className="row around-xs elementVisible">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div style={{ textAlign: "center" }}>
                            <b>Are you sure you want to cancel the Financing application?</b>
                        </div>
                         <br />

                        <div className="fbaPSize" style={{ textAlign: "center" }}>
                            <b>You can reapply anytime.</b>
                        </div>
                        <br />
                    </div>
                </div>
             

                <div className="row around-xs inputPair elementVisible">
                    <div className="col-6" style={{ textAlign: "left" }}>
                        <Button
                            look="outline"
                            className="btSize1 sccbTxt2"
                            onClick={props.backClick} >
                            Back
                        </Button>
                    </div>
                    <div className="col-6" style={{ textAlign: "right" }}>
                        <Button
                            look="outline"
                            className="btWidth sccbTxt2"
                            onClick={props.nextClick} >
                            Cancel Application
                        </Button>
                    </div>
                    
                </div>
            </Popup>
        </div>
    )
}

export default CusCancelApp;